import { render, staticRenderFns } from "./oldRecordWhitelistMain.vue?vue&type=template&id=c9f242ac&scoped=true"
import script from "./oldRecordWhitelistMain.vue?vue&type=script&lang=js"
export * from "./oldRecordWhitelistMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9f242ac",
  null
  
)

export default component.exports